export default () => ({
    loading: false,
    text: null,
    available: null,

    addToCart(form, button) {
        this.loading = true;

        if (!this.available) {
            button.setAttribute("aria-disabled", "true");
        } else {
            button.setAttribute("aria-disabled", "false");
        }

        if (button.getAttribute('aria-disabled') === 'true') return;

        const config = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': `application/javascript` }
        };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
    
        let formData = new FormData(form);
        config.body = formData;
        
        fetch(`${routes.cart_add_url}`, config)
        .then(response => {
            this.loading = false;
            this.$dispatch('cart-updated');
            this.$dispatch('cart-notice');
            //this.$dispatch('cart-count-updated');

            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
        
        return false;  
    },
    initForm() {
        const _this = this;
        const button = this.$refs.submitButton;
        const form = this.$refs.addToCartForm;

        form.addEventListener("submit", function(event) {
            
            event.preventDefault();

            _this.addToCart(form, button);
        });
    }
});